import api from './api';

/**
 * Super-admin catalogue manager (/api/admin/micro-sims): content upload, versions and
 * publishing.
 */

const fileForm = (file, extra = {}) => {
  const form = new FormData();
  form.append('file', file);
  Object.entries(extra).forEach(([k, v]) => { if (v !== undefined && v !== null) form.append(k, v); });
  return form;
};

const adminMicroSimService = {
  // ---- topics and versions ----
  listTopics: () => api.get('/admin/micro-sims'),
  getTopic: (slug) => api.get(`/admin/micro-sims/topics/${encodeURIComponent(slug)}`),
  // Check a file without saving: { report: { valid, conversionErrors, errors, warnings, summary } }
  validate: (file) => api.upload('/admin/micro-sims/validate', fileForm(file)),
  createDraft: (file, changeNote) => api.upload('/admin/micro-sims/drafts', fileForm(file, { changeNote })),
  publish: (versionId) => api.post(`/admin/micro-sims/versions/${versionId}/publish`),
  unpublish: (slug) => api.post(`/admin/micro-sims/topics/${encodeURIComponent(slug)}/unpublish`),
  deleteDraft: (versionId) => api.delete(`/admin/micro-sims/versions/${versionId}`),
  downloadVersion: (versionId, format) =>
    api.download(`/admin/micro-sims/versions/${versionId}/content.${format}`, `micro-sim.${format}`),
  downloadTemplate: () => api.download('/admin/micro-sims/template.xlsx', 'micro-sim-template.xlsx'),
  downloadExample: () => api.download('/admin/micro-sims/example.xlsx', 'micro-sim-example.xlsx'),
};

export default adminMicroSimService;
